import { Component, inject, Input, Signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { Observable } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { RoadControlsForm } from './road-controls.form';
import { ExposedMapDictionary, ExposedMapDictRoad } from '../../../../../../common/exposed-map/exposed-map.component';
import { RoadDictionaryAppEntityDictionaryRoadDictionary, RoadDictionaryService } from '../../../../../../openapi';

@Component({
  selector: 'app-road-controls-set',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ValidationErrorsComponent,
    ReactiveFormsModule
  ],
  templateUrl: './road-controls-set.component.html'
})
export class RoadControlsSetComponent {

  @Input()
  public hideStreetControl = false;

  private defaultRoadDict$: Observable<RoadDictionaryAppEntityDictionaryRoadDictionary[]> = inject(RoadDictionaryService).getRoadDictionaryCollectionRoadDictionaryCollection({
    pagination: false
  });

  public defaultRoadDict: Signal<RoadDictionaryAppEntityDictionaryRoadDictionary[] | undefined> = toSignal(this.defaultRoadDict$);

  @Input()
  public form: RoadControlsForm | undefined;

  @Input()
  set expMapDict(data: ExposedMapDictionary | undefined) {
    const road: ExposedMapDictRoad | null = data?.roads.at(0) || null;
    if (road) {
      this.form?.roadNumber?.setValue(road?.roadNo);
      this.roadNumberChange(road?.roadNo || '');
      this.form?.roadName?.setValue(road?.roadName);
      this.form?.street?.setValue(road?.street || '');
    }
  }

  public roadNumberChange(value: string): void {
    const selected = this.defaultRoadDict()?.filter(v => v.roadNumber === value).at(0);
    this.form?.roadName.setValue(selected?.roadName || '');
  }
}
